import { Pipe, PipeTransform } from '@angular/core';
import { PaymentMethod } from '../../core/data';

@Pipe({
  name: 'paymentMethodText',
})
export class PaymentMethodTextPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case PaymentMethod.BPAY: return 'BPay';
      case PaymentMethod.CREDIT_CARD: return 'Credit/Debit Card';
      case PaymentMethod.DIRECT_DEBIT: return 'Direct Debit';
      default: return 'Unknown Payment Method';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/payment-method-text.pipe.ts